import React from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { Card, Spin, Typography } from 'antd'
import * as Styled from './style'

const QUERY = gql`
  query GetCartDeliveryOptions($customerId: String!, $provinceId: ID!, $districtId: ID!) {
    customerCart(customerNo: $customerId) {
      id
      deliveryOptions(provinceId: $provinceId, districtId: $districtId) {
        name
        type
        totalPrice
        processingTimeLabel
      }
    }
  }
`

const optionsParser = customerCart => {
  if (!customerCart) return []

  return customerCart.deliveryOptions || []
}

const renderOptions = (options, onChange, value) => {
  return options.map(option => {
    return (
      <Styled.Card key={option.type} $active={`${option.type === value}`}>
        <Card.Grid onClick={() => onChange(option)}>
          <Typography.Text strong>{option.name}</Typography.Text>
          <Typography.Text type="secondary">{option.processingTimeLabel}</Typography.Text>

          <Typography.Text type="danger" strong>{option.totalPrice}</Typography.Text>
        </Card.Grid>
      </Styled.Card>
    )
  })
}

const CartDeliveryOptions = ({
  customerId,
  provinceId,
  districtId,
  onChange,
  value
}) => {
  const { data, loading, error } = useQuery(QUERY, {
    skip: !provinceId || !districtId,
    notifyOnNetworkStatusChange: true,
    variables: { customerId, provinceId, districtId },
    onCompleted: ({ customerCart }) => {
      const option = customerCart.deliveryOptions[0]
      if (!option) return null

      if (option.type !== value) {
        onChange(option)
      }
    }
  })

  if (error) { console.error(error) }
  if (loading) return <Spin />

  const options = optionsParser(data.customerCart)

  return (
    <Styled.Wrapper>
      <Card loading={loading}>
        {renderOptions(options, onChange, value)}
      </Card>
    </Styled.Wrapper>
  )
}

CartDeliveryOptions.propTypes = {
  customerId: PropTypes.string.isRequired,
  provinceId: PropTypes.string,
  districtId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
}

export default CartDeliveryOptions
